<template>
  <div>
    <!-- Random Segment Manager Modal -->
    <b-modal
      id="featureTableModal"
      size="xl"
      content-class="menu-bg-blue-transparent-modal ansi-ft-modal"
      body-class="scroll-Container"
      :title="
        layerDefinition == 'Intersections'
          ? 'Intersections Feature Table'
          : 'ANSI Feature Table'
      "
      hide-footer
      scrollable
      @show="loadTable()"
      @hidden="displayUntestedRegions = false"
    >
      <!-- Status Counts -->
      <b-row>
        <b-col v-if="untestedRegions.length > 0" align-self="center" cols="1">
          <b-button
            @click="displayUntestedRegions = !displayUntestedRegions"
            :variant="displayUntestedRegions ? 'primary' : 'secondary'"
            :title="
              (displayUntestedRegions ? 'Hide' : 'Show') + ' Untested Regions'
            "
            size="lg"
          >
            <fa :icon="['fas', 'globe-americas']" size="lg" />
          </b-button>
        </b-col>
        <b-col v-for="(element, i) in statusCounts" :key="i" class="px-1">
          <div class="ft-status-card">
            <span class="ft-status-count">{{ element.count }}</span>
            <span class="ft-status-label capitalize" v-if="element.Overall">{{ element.Overall }}</span>
            <span class="ft-status-label" v-else>Not Reviewed</span>
          </div>
        </b-col>
      </b-row>
      <!-- Untested Regions Display -->
      <div v-if="displayUntestedRegions" class="pb-3">
        <b-row>
          <b-col>
            <h3>Untested Regions:</h3>
          </b-col>
        </b-row>
        <div style="column-count: 5">
          <b-row v-for="(element, index) in untestedRegions" :key="index">
            <b-col>
              <ul class="ul-less-margin">
                <li>{{ element }}</li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>
      <b-row class="mx-2 my-1" v-if="layerDefinition == 'HD'">
        <b-col class="col-md-8">
          <label>Layer Types</label>
          <b-form-select
            v-model="hdLayerOption"
            class="propStyle"
            @change="getTableBySelset()"
          >
            <b-form-select-option
              v-for="(e, i) in hdLayerList"
              :key="i"
              :value="e"
            >
              {{ e }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>
      <MMP_QueryConstructor
        class="show-desktop px-4"
        :comp="layerDefinition == 'Intersections' ? 'Intersections' : 'ANSI'"
        :fromdate="null"
        :todate="null"
        :isAdmin="isAdmin"
        :user="user"
        :getPropsApiUrl="getPropsApiUrl"
        :getFilterApiUrl="getFilterApiUrl"
        :getConditions="getConditions"
        :reOpened="reOpened"
        @applyCustomQuery="applyCustomQuery($event)"
      ></MMP_QueryConstructor>
      <!-- ANSI Feature Table -->
      <vue-bootstrap4-table
        v-show="dataLoaded"
        :rows="rows"
        :columns="layerDefinition != 'HD' ? columns : hdcolumns"
        :config="config"
        :classes="layerDefinition != 'HD' ? classes : hdclasses"
        @on-select-row="zoomToFeature($event)"
      ></vue-bootstrap4-table>
      <!-- Loading Spinner -->
    </b-modal>
  </div>
</template>

<style>
/* ── Modal header (dark blue strip at top) ─────────────── */
.ansi-ft-modal .modal-header {
  background: #063c6d;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 12px 20px;
  border-radius: 7px 7px 0 0;
}

.ansi-ft-modal .modal-title {
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff;
  text-shadow: none;
}

/* ── Scrollbar ─────────────────────────────────────────── */
.ansi-ft-modal .scroll-Container {
  scrollbar-width: thin;
  scrollbar-color: rgba(6, 60, 109, 0.25) transparent;
}
.ansi-ft-modal .scroll-Container::-webkit-scrollbar { width: 4px; }
.ansi-ft-modal .scroll-Container::-webkit-scrollbar-track { background: transparent; }
.ansi-ft-modal .scroll-Container::-webkit-scrollbar-thumb { background: rgba(6, 60, 109, 0.25); border-radius: 2px; }
.ansi-ft-modal .scroll-Container::-webkit-scrollbar-button { display: none; }

/* ── Status count cards ────────────────────────────────── */
.ft-status-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 6px;
  background: rgba(6, 60, 109, 0.06);
  border: 1px solid rgba(6, 60, 109, 0.15);
  border-radius: 6px;
  text-align: center;
  margin-bottom: 8px;
}
.ft-status-count {
  font-size: 1.4rem;
  font-weight: 700;
  color: #063c6d;
  line-height: 1;
}
.ft-status-label {
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(6, 60, 109, 0.55);
}

/* ── Untested regions ──────────────────────────────────── */
.ul-less-margin {
  margin-bottom: 0.5rem;
}
.ansi-ft-modal h3 {
  color: #063c6d;
  font-size: 0.9rem;
  font-weight: 700;
  text-shadow: none;
}
.ansi-ft-modal .ul-less-margin li {
  color: rgba(6, 60, 109, 0.8);
  font-size: 0.75rem;
}
.untested-region-row {
  background: rgba(220, 53, 69, 0.08) !important;
}

/* ── Toggle button (show/hide untested) ────────────────── */
.ansi-ft-modal .btn-primary {
  background: #063c6d !important;
  border-color: #063c6d !important;
  color: #fff !important;
}
.ansi-ft-modal .btn-secondary {
  background: transparent !important;
  border-color: rgba(6, 60, 109, 0.3) !important;
  color: rgba(6, 60, 109, 0.65) !important;
}
.ansi-ft-modal .btn-secondary:hover {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
}

/* ── Form controls ─────────────────────────────────────── */
.ansi-ft-modal label {
  color: rgba(6, 60, 109, 0.65);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.ansi-ft-modal select,
.ansi-ft-modal .propStyle {
  background: #fff !important;
  border: 1px solid rgba(6, 60, 109, 0.25) !important;
  color: #063c6d !important;
  border-radius: 4px;
}
.ansi-ft-modal select option {
  background: #fff;
  color: #063c6d;
}
.ansi-ft-modal input[type="text"],
.ansi-ft-modal input[type="search"] {
  background: #fff !important;
  border: 1px solid rgba(6, 60, 109, 0.25) !important;
  color: #063c6d !important;
  border-radius: 4px;
}
.ansi-ft-modal input::placeholder {
  color: rgba(6, 60, 109, 0.35) !important;
}

/* ── Global search (vue-bootstrap4-table) ──────────────── */
/* Keep the clear (ⓧ) icon inside the right edge of the search input. The
   wrapper is a flex row so the icon centers on the input itself; the negative
   margin pulls it over the input's right padding. Selector specificity has to
   beat the library's scoped `.has-clear-right .form-control-feedback`. */
.ansi-ft-modal .vbt-global-search .has-clear-right {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.ansi-ft-modal .vbt-global-search .has-clear-right input {
  flex: 1 1 auto;
  margin: 0;
  padding-right: 2rem;
}
.ansi-ft-modal .vbt-global-search .has-clear-right .vbt-global-search-clear {
  position: static;
  order: 1;
  flex: 0 0 2rem;
  width: 2rem;
  height: auto;
  margin-left: -2rem;
  line-height: 1;
  text-align: center;
  z-index: 2;
  cursor: pointer;
  color: rgba(6, 60, 109, 0.5);
}
.ansi-ft-modal .vbt-global-search .has-clear-right .vbt-global-search-clear:hover {
  color: #063c6d;
}

/* ── Table ─────────────────────────────────────────────── */
.ansi-ft-modal table {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.ansi-ft-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.ansi-ft-modal thead th a,
.ansi-ft-modal thead th svg {
  color: rgba(6, 60, 109, 0.5) !important;
}
.ansi-ft-modal tbody tr {
  cursor: pointer;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.ansi-ft-modal tbody tr:hover {
  background: rgba(6, 60, 109, 0.04) !important;
}
.ansi-ft-modal tbody td {
  border-color: rgba(6, 60, 109, 0.08) !important;
  color: #063c6d !important;
  font-size: 0.9rem;
  text-shadow: none !important;
}

/* ── Loading spinner ───────────────────────────────────── */
.ansi-ft-modal .highlightLoader {
  color: rgba(6, 60, 109, 0.7) !important;
}
</style>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import MMP_QueryConstructor from '../shared/MMP_QueryConstructor.vue'
import {transform} from 'ol/proj'
import axios from 'axios'
export default {
  name: 'MMP_ANSI_FeatureTable',
  components: {
    VueBootstrap4Table,
    MMP_QueryConstructor
  },
  props: [
    'apiUrl',
    'ansiSelectedSelset',
    'currentANSIPartNumber',
    'hdLayerSelected',
    'isAdmin',
    'layerDefinition',
    'map',
    'user'
  ],
  data() {
    return {
      columns: [
        {
          column_text_alignment: 'text-left',
          label: 'SEGMENT ID',
          name: 'ansi_id',
          row_text_alignment: 'text-left',
          uniqueId: true
        },
        {
          column_text_alignment: 'text-left',
          label: 'Region',
          name: 'region',
          row_text_alignment: 'text-left',
          sort: true,
          initial_sort: true
        },
        {
          column_text_alignment: 'text-left',
          label: 'Technician',
          name: 'technician',
          row_text_alignment: 'text-left'
        },
        {
          column_text_alignment: 'text-left',
          label: 'Notes',
          name: 'notes',
          row_text_alignment: 'text-left'
        },
        {
          column_text_alignment: 'text-left',
          label: 'Status',
          name: 'status',
          row_text_alignment: 'text-left'
        }
      ],
      hdcolumns: [
        {
          column_text_alignment: 'text-left',
          label: 'ID',
          name: 'ansi_id',
          sort: true,
          row_text_alignment: 'text-left',
          uniqueId: true
        },
        {
          column_text_alignment: 'text-left',
          label: 'Type',
          name: 'type',
          row_text_alignment: 'text-left',
          sort: true,
          initial_sort: true
        },
        {
          column_text_alignment: 'text-left',
          label: 'Technician',
          name: 'technician',
          sort: true,
          row_text_alignment: 'text-left'
        },
        {
          column_text_alignment: 'text-left',
          label: 'Notes',
          name: 'notes',
          row_text_alignment: 'text-left'
        },
        {
          column_text_alignment: 'text-left',
          label: 'Status',
          name: 'status',
          sort: true,
          row_text_alignment: 'text-left'
        }
      ],
      config: {
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          // Wait 250ms post-keyup to begin search.
          // 60ms is default, but too low of a value can cause lag.
          searchDebounceRate: 250
        },
        highlight_row_hover_color: '#4a4a4a',
        pagination: false,
        rows_selectable: true,
        show_refresh_button: false,
        show_reset_button: false
      },
      classes: {
        row: {
          'untested-region-row': row => {
            return this.untestedRegions.includes(row.region)
          }
        },
        table: {
          'menu-bg-blue-transparent': true
        }
      },
      hdclasses: {
        table: {
          'menu-bg-blue-transparent': true
        }
      },
      rows: [],
      selsetData: [],
      statusCounts: null,
      dataLoaded: false,
      untestedRegions: [],
      displayUntestedRegions: false,
      getPropsApiUrl: null,
      getFilterApiUrl: null,
      getConditions: null,
      hdLayerList: ['movable_bridges', 'movable_barriers', 'tolls', 'tunnels'],
      hdLayerOption: 'movable_bridges',
      customReportUrl: null,
      customFeatureTableUrl: null,
      customPropsUrl: null,
      customTableUrl: null,
      prevType: null,
      reOpened: false,
      prevSelset: null,
      feedback: null,
      previousAnsiSegment: null
    }
  },
  methods: {
    getRows() {
      this.rows = []
      this.untestedRegions = []
      let testedRegions = []
      if (this.layerDefinition == 'HD') {
        for (let index in this.selsetData) {
          let data = this.selsetData[index]
          this.rows.push({
            id: data.road_segment_id,
            type: data.type,
            technician: data.technician,
            notes: data.notes,
            status: data.Overall,
            x: data.x,
            y: data.y,
            partNumber: data.partNumber,
            selset: data.selset,
            ansi_id: data.ansi_id,
            speed_limit_value: data.speed_limit_value
          })
        }
      } else {
        if (this.layerDefinition == 'Intersections') {
          for (let index in this.selsetData) {
            let data = this.selsetData[index]
            if (!testedRegions.includes(data.region)) {
              let untested = this.untestedRegions.indexOf(data.region)
              if (untested == -1) {
                // Region is untested
                if (data.Overall) {
                  // Record has value
                  testedRegions.push(data.region)
                } else {
                  // Record has no value
                  this.untestedRegions.push(data.region)
                }
              } else if (data.Overall) {
                // Region is tested and record has value
                testedRegions.push(this.untestedRegions[untested])
                this.untestedRegions.splice(untested, 1)
              }
            }
            this.rows.push({
              ansi_id: data.intersection_id,
              region: data.region,
              technician: data.technician,
              notes: data.notes,
              status: data.Overall,
              x: data.x,
              y: data.y,
              partNumber: data.partNumber,
              selset: data.selset,
              speed_limit_value: data.speed_limit_value
            })
          }
        } else {
          for (let index in this.selsetData) {
            let data = this.selsetData[index]
            if (!testedRegions.includes(data.region)) {
              let untested = this.untestedRegions.indexOf(data.region)
              if (untested == -1) {
                // Region is untested
                if (data.Overall) {
                  // Record has value
                  testedRegions.push(data.region)
                } else {
                  // Record has no value
                  this.untestedRegions.push(data.region)
                }
              } else if (data.Overall) {
                // Region is tested and record has value
                testedRegions.push(this.untestedRegions[untested])
                this.untestedRegions.splice(untested, 1)
              }
            }
            this.rows.push({
              id: data.road_segment_id,
              region: data.region,
              technician: data.technician,
              notes: data.notes,
              status: data.Overall,
              x: data.x,
              y: data.y,
              partNumber: data.partNumber,
              selset: data.selset,
              ansi_id: data.ansi_id,
              speed_limit_value: data.speed_limit_value
            })
          }
        }
        // Alphabetizes array
        this.untestedRegions.sort()
      }
    },
    getCountsBySelset() {
      this.formulateUrls()
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              '/api/' +
              this.apiUrl +
              this.customReportUrl,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              this.feedback = content.errors[0].msg
            } else {
              this.feedback = null
              this.statusCounts = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({name: 'Login'})
      }
    },
    async getTableBySelset() {
      await this.formulateUrls()
      this.dataLoaded = false
      if (sessionStorage.token) {
        let retVal = await axios
          .get(
            `${process.env.API_LOCATION}/api/${this.apiUrl}${this.customTableUrl}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(async (response) => {
            const content = response.data
            if (content.errors) {
              this.feedback = content.errors[0].msg
            } else {
              this.feedback = null
              this.selsetData = null 
              this.selsetData = content
              await this.getRows()
              return this.selsetData
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        return retVal
      } else {
        this.$router.push({name: 'Login'})
      }
    },
    zoomToFeature(row) {
      if (this.previousAnsiSegment) {
        this.saveEndTimeForAnsi(this.previousAnsiSegment)
      }
      this.saveStartTimeForAnsi(row.selected_item)
      this.previousAnsiSegment = row.selected_item
      this.$emit('changeOtonomoSubcountry', row.selected_item.region)
      let x = row.selected_item.x
      let y = row.selected_item.y
      if (x != null && y != null) { // REFACTORED -- WEBGIS-2550 -- changed from || to && - can't change view if one value is null
        var coord = new transform([x, y], 'EPSG:4326', 'EPSG:3857')
        this.map.getView().setCenter(coord)
        this.map.getView().setZoom(19.5)
      }
      // REFACTOR SUGGESTION - WEBGIS-2550 - should we call these two lines below if x == null || y == null?? Error Message??
      this.$emit('toggleLidarPanel')
      this.$bvModal.hide('featureTableModal')
      this.$parent.$parent.$refs.ansiNav.setAnsiSegmentsHistory(this.selsetData, row)
      this.$emit('setSpeedLimit', row)
      //reverted Lidar autoload code
    },
    saveStartTimeForAnsi(data) {
      // This ternary operator handles Subaru ANSI random segments which does not have segment id but has ushr ANSI Id instead.
      if (sessionStorage.token) {
        // REFACTORED -- WEBGIS-2550 -- Adding check to see if data is empty since there's issues with saving review time
        if (data) {
          axios
          .get(
            process.env.API_LOCATION +
              '/api/' +
              this.apiUrl +
              '/saveStartTimeForAnsi/',
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                partNumber: this.currentANSIPartNumber.part_number,
                segmentId: data.ansi_id,
                selset: data.selset
              }
            }
          )
          .catch(function (error) {
            console.log(error)
          })
        } else {
          console.log('Error saving start time for Ansi Segment - no data available')
        }
      } else {
        this.$router.push({name: 'Login'})
      }
    },
    saveEndTimeForAnsi(data) {
      if (sessionStorage.token) {
        if (data) {
          axios
          .get(
            process.env.API_LOCATION +
              '/api/' +
              this.apiUrl +
              '/saveEndTimeForAnsi/',
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                partNumber: this.currentANSIPartNumber.part_number,
                segmentId: data.ansi_id
              }
            }
          )
          .catch(function (error) {
            console.log(error)
          })
        } else {
          console.log('Error saving end time for Ansi Segment - no data available')
        }
      } else {
        this.$router.push({name: 'Login'})
      }
    },
    endAnsiSegmentReview() {
      if (this.previousAnsiSegment) {
        this.saveEndTimeForAnsi(this.previousAnsiSegment)
        this.previousAnsiSegment = null
      }
    },
    trackAnsiSegmentReview(segment) {
      this.previousAnsiSegment = segment
    },
    async loadTable() {
      if (
        this.rows.length == 0 ||
        this.prevType != this.layerDefinition ||
        this.prevSelset != this.ansiSelectedSelset
      ) {
        this.prevType = this.layerDefinition
        this.selsetData = null
        this.statusCounts = null
        this.prevSelset = this.ansiSelectedSelset
        this.rows = []
        this.reOpened = false
        await this.getTableBySelset()
      } else {
        await this.getTableBySelset()
        this.reOpened = true
      }
      await this.getCountsBySelset()
      this.dataLoaded = true
      this.reOpened = false
    },
    applyCustomQuery(queryRows) {
      this.rows = queryRows.rows
      this.getConditions = queryRows.cond
    },
    formulateUrls() {
      let partNumber = this.currentANSIPartNumber.part_number
      if (this.layerDefinition == 'Intersections') {
        this.customFeatureTableUrl =
          '/filterIntersectionFeatureTable/' + this.ansiSelectedSelset
        this.customTableUrl = '/intersectionTable/' + this.ansiSelectedSelset
        this.customReportUrl = '/intersectionReport/' + this.ansiSelectedSelset
        this.customPropsUrl = '/filterIntersectionProps'
      } else {
        this.customFeatureTableUrl =
          this.layerDefinition == 'HD'
            ? '/filterHdFeatureTable/' + partNumber + '/' + this.hdLayerOption
            : '/filterFeatureTable/' + this.ansiSelectedSelset
        this.customPropsUrl =
          this.layerDefinition == 'HD' ? '/filterHDProps/' : '/filterProps/'
        this.customTableUrl =
          this.layerDefinition == 'HD'
            ? '/HDtable/' + partNumber + '/' + this.hdLayerOption
            : '/table/' + this.ansiSelectedSelset
        this.customReportUrl =
          this.layerDefinition == 'HD'
            ? '/HDreport/' + partNumber + '/' + this.hdLayerOption
            : '/report/' + this.ansiSelectedSelset
      }
      this.getFilterApiUrl =
        process.env.API_LOCATION +
        '/api/' +
        this.apiUrl +
        this.customFeatureTableUrl
      this.getPropsApiUrl =
        process.env.API_LOCATION + '/api/' + this.apiUrl + this.customPropsUrl
    }
  },
  watch: {
    getPropsApiUrl: function (newValue, oldValue) {
      this.getPropsApiUrl = newValue
    },
    layerDefinition: function (newValue, oldValue) {
      this.layerDefinition = newValue
    },
    currentANSIPartNumber: function (newValue) {
      this.getConditions = []
    }
  }
}
</script>
